'use client';

import { useEffect, useRef } from 'react';
import { pushToDataLayer } from './ga-core';

interface SendGACampaignAccessProps {
  shopName?: string | null;
  lotteryId: number;
}

/**
 * 特定のキャンペーン/流入経路経由のアクセスを検知し、GA4イベントを送信するコンポーネント
 * ページロード時に一度だけイベントを送信します。
 */
const SendGACampaignAccess: React.FC<SendGACampaignAccessProps> = ({ shopName, lotteryId }) => {
  const sendingRef = useRef(false);

  useEffect(() => {
    if (shopName && !sendingRef.current) {
      sendingRef.current = true;

      //GA用イベント（campaign_access_lottery_detail）呼び出し
      pushToDataLayer('campaign_access_lottery_detail', {
        shop_name: shopName,
        lottery_id: lotteryId,
      });
    }
  }, [shopName, lotteryId]);
  return null;
};

export default SendGACampaignAccess;
